/**
 * True on touch-first / small-screen devices, where the 3D avatar and the
 * 360° viewer share one weak GPU. Evaluated on the client only.
 */
export function isLowPowerDevice(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 768;
}
